"use client";
import { useEffect, useRef, useState } from "react";
import { Tabs } from "antd";
import type { TabsProps } from 'antd';
import Link from "next/link";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from 'swiper';
import useMobileDetect from "@/hooks/useMobileDetect";
import { handleCardClick1 } from "@/utils/tools";
import { CardType } from "@/types/index";
import ImageWithSkeleton from "@/app/components/common/ImageWithSkeleton";

import './index.css'

type tabProps = {
  isFirstMobile?: boolean,
  list: any[],
  title?: string,
  idx: number
}
export const TabMediaCardList: React.FC<tabProps> = ({ isFirstMobile, list, title, idx }) => {
  const isMobile = useMobileDetect(isFirstMobile);
  const [activeTab, setActiveTab] = useState(0);
  const swiperRef = useRef<SwiperType | null>(null);

  const items: TabsProps['items'] = list.map((item: {
    tabName: string
  }, idx: number) => ({
    key: idx.toString(),
    label: <h2 className={`${isMobile ? 'text-[22px]' : ''}`}>{item.tabName}</h2>,
    children: false
  }))

  // 切换到指定索引的幻灯片
  const goToSlide = (index: number) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(index); // 调用 slideTo 方法
      setActiveTab(index); // 更新当前索引状态
    }
  };

  const onChange = (key: string) => {
    const idx = parseInt(key)
    setActiveTab(idx)
    goToSlide(idx)
    // @ts-ignore
    const userInfoStr = globalThis?.localStorage?.getItem("userInfo")
    let userInfo
    if (userInfoStr) {
      userInfo = JSON.parse(userInfoStr)
    }
    // @ts-ignore
    window.gtag('event', 'card_click', {
      card_type: CardType.TAB_MEDIA_CARD_LIST,
      card_position: idx,
      click_time: Date(),
      click_area: 'Tab -' + list[idx]?.tabName,
      target_url: '',
      user_id: userInfo?.id
    });
  };

  return (<div className="TabMediaCardList">
    {
      title ?
        <h2 className={`text-bravve-sub-100 leading-24 text-lg ${isMobile ? 'mb-24' : 'mb-40'} mx-20 md:mx-40 `}>
          {title}
        </h2>
        :
        null
    }

    <Tabs activeKey={activeTab + ''} items={items} onChange={onChange} />

    <Swiper
      className="ProductListCarousel"
      onSwiper={(swiper) => {
        swiperRef.current = swiper; // 存储 Swiper 实例
      }}
      onSlideChange={(swiper) => {
        setActiveTab(swiper.activeIndex); // 更新当前索引状态
      }}
    >
      {list.map(
        (item: {
          pcPicture: string,
          h5Picture: string,
          pictureAlt: string,
          link: {
            url?: string,
            target?: string,
            type?: string,
          }
        }, idx: number) => {
          return (
            <SwiperSlide key={item.pcPicture}>
              {
                handleCardClick1({ ...item, ...item.link, idx },
                  <div className="relative w-full" 
                    style={{ aspectRatio: isMobile ? '1/1' : '2880/1260', paddingTop: isMobile ? '100%': '43.75%' }}> 
                    <ImageWithSkeleton
                      src={isMobile ? process.env.NEXT_PUBLIC_IMAGE_URL + item.h5Picture : process.env.NEXT_PUBLIC_IMAGE_URL + item.pcPicture}
                      alt={item.pictureAlt}
                      width={100}
                      height={100}
                    />
                  </div>
                  // <Image
                  //   src={isMobile ? process.env.NEXT_PUBLIC_IMAGE_URL + item.h5Picture : process.env.NEXT_PUBLIC_IMAGE_URL + item.pcPicture}
                  //   alt={item.pictureAlt}
                  //   width={100}
                  //   height={100}
                  //   className="ant-skeleton-image-self"
                  //   loading="lazy"
                  //   style={{ width: '100%', aspectRatio: isMobile ? '1/1' : '2880/1260' }}
                  // />
                  , isMobile)
              }
            </SwiperSlide>
          );
        }
      )}
    </Swiper>
  </div>)
}